export default __webpack_public_path__ + "static/mpm-3fa79d03a44c3d7cc959cdfe1a8bb93f.svg";